<tr class="total two-columns-group-sticky">
  <td class="col-first-level">
    <app-table-group-icon data-qa="bm-hide-opex-section"
                          [formControl]="budgetForm().controls.modelData.controls.operatingExpenses.controls.showSection"/>
  </td>
  <td class="col-second-level" colspan="3">
    <div class="flex justify-between items-center">
      <div>Operating expenses</div>
      @if (isEditState()) {
        <app-button
          data-qa="bm-add-button-op-exp"
          [size]="'xxsmall'"
          [type]="'grey-accent'"
          [iconName]="'plus.svg'"
          (buttonClick)="onOpExpGroupAction(BmGroupAction.ADD)">Item
        </app-button>
      }
    </div>
  </td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.operatingExpenses.total; track data) {
    <td
      [attr.data-qa]="'bm-op-ex-total-' + data.period.quarterNumber + '-' + data.period.yearNumber"
      class="bold600"
      [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
      [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
      {{ data.itemValue | switcherDashBraces : 1 : 0 }}
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="fix-w-0p25 blank-space right-sticky right-[5.5rem]"></td>
  <td class="fix-w-5p5 right-sticky right-0">
    <div class="flex flex-col">
      <span data-qa="bm-op-ex-row" class="bold600">{{ budgetFormValue$$().modelData.operatingExpenses.totalRow | switcherDashBraces : 1 : 0 }}</span>
      <span data-qa="bm-op-ex-row-pcnt" class="caption-3 black-9 bold600">{{ budgetFormValue$$().modelData.operatingExpenses.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%' }}</span>
    </div>
  </td>
</tr>
@for (group of budgetFormValue$$().modelData.operatingExpenses.groups; track group) {
  @let groupControl = budgetForm().controls.modelData.controls.operatingExpenses.controls.groups.controls[$index];
  @if (budgetForm().value.modelData.operatingExpenses.showSection) {
    <tr
      appOnHover #hover="onHover"
      cdkDrag
      [ngClass]="isEditState() ? 'three-columns-group-sticky' : 'two-columns-group-sticky'"
      [cdkDragDisabled]="!isEditState() || group.isRenameMode">
      @if (isEditState()) {
        <td
          class="col-first-level">
          @if (!group.isRenameMode) {
            <app-all-icons
              cdkDragHandle
              [attr.data-qa]="'bm-op-ex-drag-handle-' + group.name"
              [iconNameAndStyling]="'drop-icon.svg;drag-icon icon-size-1p375 cursor-grab'">
            </app-all-icons>
          }
        </td>
      }
      <td [ngClass]="isEditState() ? 'col-second-level' : 'col-first-level'">
        @if (isEditState()) {
          <app-three-dots-menu [matMenuTriggerFor]="isEditState() ? menu : null">
            <mat-menu #menu="matMenu">
              <ul class="list">
                <app-drop-down-item
                  [attr.data-qa]="'bm-op-ex-rename-gr' + group.name"
                  class="w-full"
                  [text]="'Rename'"
                  [iconNameAndStyling]="'edit.svg'"
                  (click)="onOpExpGroupAction(BmGroupAction.RENAME, groupControl)">
                </app-drop-down-item>
                <app-drop-down-item
                  [attr.data-qa]="'bm-op-ex-duplicate-gr' + group.name"
                  class="w-full"
                  [text]="'Duplicate'"
                  [iconNameAndStyling]="'copy.svg'"
                  (click)="onOpExpGroupAction(BmGroupAction.DUPLICATE, groupControl)">
                </app-drop-down-item>
                <app-drop-down-item
                  [attr.data-qa]="'bm-op-ex-delete-gr' + group.name"
                  class="w-full"
                  [text]="'Delete'"
                  [menuItemClass]="'red'"
                  [iconNameAndStyling]="'delete.svg'"
                  (click)="onOpExpGroupAction(BmGroupAction.DELETE, groupControl)">
                </app-drop-down-item>
              </ul>
            </mat-menu>
          </app-three-dots-menu>
        }
      </td>
      @if (isEditState()) {
        <td [ngClass]="isEditState() ? 'col-third-level' : 'col-second-level'"
            [attr.colspan]="isEditState() ? '2' : '3'">
          <div class="flex items-center justify-between">
            @if (group.isRenameMode) {
              <app-input
                [attr.data-qa]="'bm-op-ex-group-rename-' + group.name"
                [formControl]="groupControl.controls.name"
                [isShrinked]="true"
                [suffixFirstIcon]="'close.svg; black-9'"
                [suffixSecondIcon]="groupControl.controls.name.invalid ? '' : 'check.svg; main-8'"
                [additionalClass]="groupControl.controls.name.invalid ? 'error' : ''"
                (suffixFirstIconEmitter)="onOpExpGroupAction(BmGroupAction.RENAME_CANCEL, groupControl)"
                (suffixSecondIconEmitter)="onOpExpGroupAction(BmGroupAction.RENAME_SAVE, groupControl)">
              </app-input>
            } @else {
              {{ group.name }}
            }
            <div class="flex items-center gap-0.15625">
              <app-selector
                [attr.data-qa]="'bm-op-exp-data-filling-type-' + group.name"
                class="w-[4.5rem]"
                [outerClass]="'control-shrinked-container'"
                [formControl]="groupControl.controls.dataFillingType"
                [data]="dataFillingTypes">
              </app-selector>
              @if (group.dataFillingType !== BmDataFillingType.MANUAL) {
                <app-input
                  [attr.data-qa]="'bm-op-exp-data-std-val-' + group.name"
                  class="w-[4rem]"
                  [formControl]="groupControl.controls.standardValue"
                  [isShrinked]="true"
                  [thousandSeparator]="','"
                  [separator]="'separator.0'">
                </app-input>
              } @else {
                <div class="w-[4rem]"></div>
              }
            </div>
          </div>
        </td>
        <td class="blank-space col-fifth-level"></td>
        @for (data of group.items; track data) {
          @let dataControl = groupControl.controls.items.controls[$index];
          <td
            [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
            [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
            <app-input
              [attr.data-qa]="'bm-op-ex-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
              [formControl]="dataControl.controls.itemValue"
              [isShrinked]="true"
              [thousandSeparator]="','"
              [allowNegativeNumbers]="true"
              [separator]="'separator.0'"
              [suffixFirstIcon]="dataControl.controls.itemValue.disabled ? ((hover.hovered()) ? 'edit.svg' : '') : 'close.svg'"
              (suffixFirstIconEmitter)="editItemValue(dataControl, BmGroupType.EXPENSES)">
            </app-input>
          </td>
          @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
            <td
              [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
              class="blank-space">
            </td>
          }
        }
      } @else {
        <td class="col-second-level" colspan="3">{{ group.name }}</td>
        <td class="blank-space col-fifth-level"></td>
        @for (data of group.items; track data) {
          <td
            [attr.data-qa]="'bm-op-ex-val-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
            [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
            [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
            {{ data.itemValue | switcherDashBraces : 1 : 0 }}
          </td>
          @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
            <td
              [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
              class="blank-space">
            </td>
          }
        }
      }
      <td [class.bg-black-2]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
      <td class="fix-w-0p25 blank-space right-sticky right-[5.5rem]"></td>
      <td class="fix-w-5p5 right-sticky right-0">
        <div class="flex flex-col">
          <span [attr.data-qa]="'bm-op-ex-val-row-' + group.name">
            {{ groupControl.controls.totalRow.value | switcherDashBraces : 1 : 0 }}
          </span>
          <span [attr.data-qa]="'bm-op-ex-val-row-pcnt-' + group.name" class="caption-3 black-9">
            {{ groupControl.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%' }}
          </span>
        </div>
      </td>
    </tr>
  }
}
